const FIELDS = {
    quotation: {
        type: "upload",
        label: "Upload Quotation",
        isRequired: true,
        onlyImage : false,
        showImageData :false,
        style:{paddingLeft : "10px", marginBottom:"-10px"},
        size: 1024,
        xs:12,
        lg:12,
        sm:12,
        md:12
    }
};

export default FIELDS;